module.exports = "<div class=\"page-content\">\n    <div class=\"container-fluidmap\">\n    <alert-message></alert-message>\n        <div ui-view></div>\n    </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/main/page.html
 ** module id = 567
 ** module chunks = 0
 **/